<template>
  <div class="contanct">
    <section  class="contact-header unselectable">
      <h1>{{ STRINGS.CONTACT }}</h1>
    </section>

    <ContactComp />

    <section class="location unselectable">
      <div class="location-title">
        <h2>Hier finden Sie uns</h2>
      </div>

      <div class="location-map">
        <div v-if="consentStatus === null" class="map-consent">
          <p>
            Um die interaktive Karte zu sehen, müssen Sie zustimmen, dass
            <a href="/datenschutz#personal-data">personenbezogene Daten</a>
            an <a href="/datenschutz#google-maps">Google</a> übertragen werden.
          </p>
          <button @click="acceptGoogleMaps">Einwilligen</button>
          <button @click="rejectGoogleMaps">Nicht Einwilligen</button>
        </div>

        <iframe
          v-if="consentStatus === true"
          :src="STRINGS.LOCATION_EMBED"
          width="1000"
          height="600"
          style="border:0;"
          allowfullscreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

        <img
          v-if="consentStatus === false"
          :src="ASSETS.MAP_IMAGE"
          alt="map image"
          width="1000"
          height="600"
        />
      </div>
    </section>

    <section class="info-section">
      <h2 class="unselectable">PARKMÖGLICHKEITEN:</h2>
      <p>Parkplatz: Grünenplatzstraße 1, 42899 Remscheid</p>
      
      <br>

      <h2 class="unselectable">ÖFFENTLICHE VERKEHRSMITTEL:</h2>
      <p>S-Bahn Remscheid Lüttringhausen</p>
      <p>Bushaltestelle Eisernstein - Remscheid</p>
    </section>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ASSETS, STRINGS } from '@/constants';
import ContactComp from '@/components/ContactComp.vue';

@Options({
  components: {
    ContactComp
  }
})
export default class Contanct extends Vue {
  ASSETS = ASSETS;
  STRINGS = STRINGS;

  consentStatus: boolean | null = null;

  mounted() {
    const storedConsent = localStorage.getItem('googleMapsConsent');
    if (storedConsent === 'true') {
      this.consentStatus = true;
    } else if (storedConsent === 'false') {
      this.consentStatus = false;
    }
  }

  acceptGoogleMaps() {
    this.consentStatus = true;
    localStorage.setItem('googleMapsConsent', 'true');
  }

  rejectGoogleMaps() {
    this.consentStatus = false;
    localStorage.setItem('googleMapsConsent', 'false');
  }
}
</script>

<style scoped>
.contanct {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-header {
  max-width: 1000px;
  width: 90%;
  text-align: left;
  padding: 1rem;
  box-sizing: border-box;
}

.contanct h1 {
  font-size: 40px;
  margin: 0;
  margin-top: 2rem;
  color: var(--color-text-default);
  word-wrap: break-word;
}

.location {
  width: 90%;
  max-width: 1000px;
}

.location img {
  width: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.location-title {
  text-align: left;
  box-sizing: border-box;
  padding: 1rem;
}

.location-map {
  display: flex;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.info-section {
  max-width: 1000px;
  width: 90%;
  text-align: left;
  padding: 1rem;
  box-sizing: border-box;
}

.map-consent {
  padding: 1rem;
  background-color: var(--color-background-highlight);
  width: 100%;
}

.map-consent button {
  margin: 0.5rem 1rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  background-color: var(--color-button-bg);
  color: var(--color-button-text);
  border-radius: 5px;

  outline: none;
  transition: background-color 0.5s ease;
  border: 1px solid var(--color-border);
}

.map-consent button:hover {
  transition: background-color 0.2s ease;
  background-color: var(--color-button-bg-hover);
}

.map-consent p a {
  color: var(--color-text-link);
  text-decoration: none;
}
</style>